import { useStoreOrder } from '@/stores/order';

export function route(action, $this) {
  let routeObject = {};
  if (action.name) {
    routeObject.name = action.name
  } else {
    routeObject.path = action.path;
  }

  routeObject = {
    ...routeObject,
    params: action.params,
    query: action.query,
    hash: action.hash,
  }

  return $this.router.push(routeObject);
}

export function startOrder(args) {
  let orderStore = useStoreOrder();

  if (orderStore.order.delivery) {
    this.route({ name: 'order' }, args.$this);
    return;
  }

  this.route({ name: 'order-type' }, args.$this);
}

export default {
  route,
  'start-order': startOrder,
}
